import tippy, { animateFill } from 'tippy.js';
import 'tippy.js/dist/tippy.css';
import 'tippy.js/dist/backdrop.css';
import 'tippy.js/animations/shift-away.css';
import { trapFocus } from './utils.js';

const hideOnEsc = {
    name: 'hideOnEsc',
    defaultValue: true,
    fn({hide}) {
      function onKeyDown(event) {
        if (event.keyCode === 27) {
          hide();
        }
      }
  
      return {
        onShow() {
          document.addEventListener('keydown', onKeyDown);
        },
        onHide() {
          document.removeEventListener('keydown', onKeyDown);
        },
      };
    },
};

document.addEventListener('DOMContentLoaded', function() {
    // Initialize tippy.js for all elements with has-submenu class
    tippy('.has-submenu', {
        content: function(reference) {
            return reference.nextElementSibling.innerHTML;
        },
        animation: 'scale',
        allowHTML: true,
        arrow:false,
        interactive: true,
        trigger: 'click',
        placement: 'bottom',
        theme: 'light',
        animation: 'shift-away',
        offset: [0, 31],
        plugins: [hideOnEsc],

        onShow: function(instance) {
            trapFocus(instance.popper);

            if(window.innerWidth <= 992) {
                return false;
            }
            instance.reference.classList.add('active');
            instance.reference.nextElementSibling.classList.add('active');
            instance.popper.classList.add('sub-menu');
            
        },
        onHide: function(instance) {
            instance.reference.classList.remove('active');
            instance.reference.nextElementSibling.classList.remove('active');
        }
    });
});


const subnavItems = document.querySelectorAll('.has-submenu');
subnavItems.forEach(item => {
    item.addEventListener('click', function(e) {
        e.preventDefault();
        item.classList.toggle('active');
        item.nextElementSibling.classList.toggle('active');
        document.getElementById('primary-navigation').classList.toggle('sub-menu-open');
    });
});